import type { TranslationKeysError } from '../localeType';

export const esES_error: TranslationKeysError = {
  error: 'Error:',
  // Update ORDER
  ORDER_NOT_FOUND: `No se ha encontrado el pedido`,
  ORDER_SUSPENDED: `El pedido est á suspendido`,
  ORDER_IN_USE: `El pedido est á en uso`,
  FLORIST_NOT_FOUND: `El código de florista no se ha encontrado`,
  NOTIFICATION_CHANNEL_EMPTY: `Ocurri ó un error en el sistema`,
  UPDATE_NOT_ALLOWED_WRONG_STATUS: `El pedido no se puede cambiar a este estado`,
  UPDATE_NOT_ALLOWED_WRONG_EXECUTOR: `El usuario no puede modificar el pedido`,
  UPDATE_KO: `El estado del pedido se ha cambiado, pero hay un error relacionado con la facturación`,
  EXCEPTION: `El pedido no puede ser actualizado. Ha ocurrido un error.`,
  UNKNOWN_EXCEPTION: `El pedido no puede ser actualizado. Ha ocurrido un error.`,
  OrderNotFoundException: `No se ha encontrado el pedido`,
  IncorrectOrderActionException: `La acción solicitada no es compatible.`,
  OrderStatusNotConsistentException: `El nuevo estado solicitado en el pedido no es posible`,
  InvariantException: `Error técnico en el sistema : HTTP BAD REQUEST`,
  // POST ORDER
  IncorrectBodyModelException: `Transmisión fallida: Error interno - Código de error: PO-01`,
  IncorrectOrderException: `Transmisión fallida: Error interno - Código de error: PO-02`,
  BadRequestException: `Transmisión fallida: Error interno - Código de error: PO-03`,
  Exception: `Transmisión fallida: Error interno - Código de error: PO-04`,
  FeasabilityExceptionRaoKo: 'Transmisión fallida: Error interno - Código de error: PO-05',
  FeasabilityExceptionRaoResponseDataKo: `Transmisión fallida: Error interno - Código de error: PO-06`,
  FeasabilityExceptionEmptyFlorists: '`Transmisión fallida: Error interno - Código de error: PO-07`',
  PersonalCodeExceptionPersonalCodeNotFound: `Transmisión fallida: Error interno - Código de error: PO-08`,
  PersonalCodeExceptionExecutingFloristMismatch: `Transmisión fallida: Error interno - Código de error: PO-09`,
  ValidationException: 'Validación del pedido imposible (campos faltantes) - Código de error: PO-10',
  PersonalCodeNeededPsm: 'Aprobación previa necesaria para producto personalizado (PSM) - Código de error: PO-11',
  PersonalCodeNeededXProduct:
    'Aprobación previa necesaria para producto con código que termina en X - Código de error: PO-12',
  PersonalCodeNeededPrice:
    'El precio supera el tamaño extra grande, se requiere un código de aprobación - Código de error: PO-12',
  PersonalCodeNeededPreparationTime:
    'Aprobación previa necesaria, tiempo de preparación demasiado corto - Código de error: PO-13',
  PersonalCodeNeededHourLimit:
    'Aprobación previa necesaria, plazo de entrega demasiado corto para la hora elegida - Código de error: PO-14',
  SelectedExecutingFloristNotFound: `Florista ejecutor no encontrado - Código de error: PO-15`,
  UpdatePersonalCodeKO: 'Imposible actualizar el código AP porque ya está en uso.',
  // LOGIN
  loginError: {
    floristUnknown: {
      title: `No se ha encontrado el login del florista.`,
      body: `Por favor, haga clic en el botón "Salir".`,
    },
    noCountryCode: {
      title: `No se ha encontrado el código de país del florista.`,
      body: `Por favor, haga clic en el botón "Salir".`,
    },
    logoutButton: `Salir`,
  },
};
